import React, { useCallback } from "react"
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import { useMobile } from "../../../../hooks/system/useMobile";
import { UserRow } from "../../hooks/useUserLoader";
import { useApi } from "../../../../hooks/useApi";
import { PasswordResetRequestFormData } from "../../../security/PasswordResetRequestForm";

export interface ConfirmResetPasswordEmailProps {
  activeUser: UserRow
  open: boolean
  onClose: () => void
}

export const ConfirmResetPasswordEmail = (p: ConfirmResetPasswordEmailProps) => {
  const isMobile = useMobile('sm'),
    { api } = useApi();
  
  const onClose = useCallback(() => {
    p.onClose();
  }, [p])

  const onSubmit = useCallback(async () => {
    const data: PasswordResetRequestFormData = {email: p.activeUser.email};
    api.postSecurityRequestPasswordReset({requestPasswordReset: data}).then(() => p.onClose())
  }, [api, p])

  return (
    <Dialog open={p.open} onClose={onClose} maxWidth='sm' fullWidth fullScreen={isMobile}>
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>This will send a password reset email to {p.activeUser.email}</DialogContent>
      <DialogActions>
          <Button size="small" onClick={p.onClose}>
            <Box m={[0, 1]}>Cancel</Box>
          </Button>
          <Button size="small" onClick={onSubmit}>
            <Box m={[0, 1]}>Submit Password Reset</Box>
          </Button>
        </DialogActions>
    </Dialog>
  )
}